import styled from "styled-components";
import { Colors } from "../../untils/Theme";

interface IFormListItemWrapperProps {
  onDragStart: (e: any, id: string) => void;
  isDraging?: boolean;
}

export const FormListItemWrapper = styled.div<IFormListItemWrapperProps>`
  border: 1px solid ${Colors.backgroundGray};
  padding: 1rem;
  background-color: ${Colors.white};
  border-radius: 0.4rem;
  display: flex;
  flex-direction: row;
  flex: 1;
  cursor: grab;
  justify-content: space-between;
  transition: 300ms;
  opacity: ${(p) => (p.isDraging ? 0.5 : 1)};
  ${(p) =>
    p.isDraging &&
    `
    `}
`;
export const LabelArea = styled.div`
  width: auto;
  height: 24px;
`;
export const IconArea = styled.div`
  width: auto;
  display: flex;
  justify-content: space-between;
`;

export const HorizontalPlaceholderWrapper = styled.div`
  width: 100%;
  height: 2.2rem;
`;

export const VerticalPlaceholderWrapper = styled.div`
  width: 2.2rem;
  height: 100%;
`;
interface IPlaceholderWrapper {
  isActive: boolean;
  onDragOver: (e: any, id: string) => void;
  mode: string;
}

export const PlaceholderWrapper = styled.div<IPlaceholderWrapper>`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  ${(p) =>
    p.mode === "horizontal" &&
    `
       > div {
    width: 100%;
    border-top: 2px dashed transparent;
  }
    
   `}
  ${(p) =>
    p.mode === "vertical" &&
    `
       > div {
    width: auto;
    border-left: 2px dashed transparent;
    height:100%;
  }`}
  ${(p) =>
    p.isActive &&
    p.mode === "horizontal" &&
    `
       > div {
        border-top: 2px dashed ${Colors.seaBlue}; 
      }
      `}
      ${(p) =>
    p.isActive &&
    p.mode === "vertical" &&
    `
       > div {
        border-left: 2px dashed ${Colors.seaBlue}; 
      }
      `}
`;
